import { NgModule, CUSTOM_ELEMENTS_SCHEMA, } from "@angular/core";
import { RouterModule, Routes, } from "@angular/router";
import { FormsModule, } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { CdkAccordionModule } from "@angular/cdk/accordion";


import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpLoaderFactory } from "../module-maps/maps.module";
import { HttpClient } from "@angular/common/http";
import { MatTabsModule } from "@angular/material/tabs";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatDividerModule } from '@angular/material/divider';

import { BottomSheetRouteDetailsComponent } from "./bottom-sheet-route-details/bottom-sheet-route-details.component";
import { BottomSheetSimpleComponent } from "./bottom-sheet-simple/bottom-sheet-simple.component";
import { ElevationProfileChartComponent } from "./elevation-profile-chart/elevation-profile-chart.component";
import { SteepnessProfileChartComponent } from "./steepness-profile-chart/steepness-profile-chart.component";
import { SurfaceProfileChartComponent } from "./surface-profile-chart/surface-profile-chart.component";
import { WaytypeProfileChartComponent } from "./waytype-profile-chart/waytype-profile-chart.component";
import { RatingComponent } from "./rating/rating.component";
import { MapsHelpComponent } from "./maps-help/maps-help.component";
import { InfosModule } from "../module-infos/infos.module";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatStepperModule } from "@angular/material/stepper";
import { MatSliderModule } from "@angular/material/slider";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { A11yModule } from "@angular/cdk/a11y";
import { MatBadgeModule } from "@angular/material/badge";

import { SavedItemsComponent } from "./saved-items/saved-items.component";
import { PresentRouteCollectionComponent } from "./present-route-collection/present-route-collection.component";
import { PublishRouteCollectionComponent } from "./publish-route-collection/publish-route-collection.component";
import { PresentRouteSingleDetailedComponent } from "./present-single-route-detailed/present-single-route-detailed.component";
import { PresentSingleRouteCollectionComponent } from "./present-single-route-collection/present-single-route-collection.component";
import { PresentSingleRouteSimpleComponent } from "./present-single-route-simple/present-single-route-simple.component";
import { ShowRouteComponent } from "./show-route/show-route.component";
import { SettingsComponent } from "../module-maps/settings/settings.component";

// const routes: Routes = [
// ];

@NgModule({
  declarations: [
    // BottomSheetRouteDetailsComponent,
    BottomSheetSimpleComponent,
    MapsHelpComponent,
    PresentRouteCollectionComponent,
    PresentRouteSingleDetailedComponent,
    PresentSingleRouteCollectionComponent,
    PresentSingleRouteSimpleComponent,
    PublishRouteCollectionComponent,
    SettingsComponent,
    ShowRouteComponent,

    ElevationProfileChartComponent,
    SavedItemsComponent,
    SteepnessProfileChartComponent,
    SurfaceProfileChartComponent,
    WaytypeProfileChartComponent,
    RatingComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    // RouterModule.forChild(routes),
    TranslateModule.forRoot({
      defaultLanguage: "en",
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),

    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatTabsModule,
    MatSliderModule,
    DragDropModule,

    A11yModule,

    InfosModule,
  ],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA], // wichtig für Custom Elements
  providers: [
  ],
  exports: [
    // BottomSheetRouteDetailsComponent,
    BottomSheetSimpleComponent,
    MapsHelpComponent,
    PresentRouteCollectionComponent,
    PresentRouteSingleDetailedComponent,
    PresentSingleRouteCollectionComponent,
    PresentSingleRouteSimpleComponent,
    PublishRouteCollectionComponent,
    SettingsComponent,
    ShowRouteComponent,

    ElevationProfileChartComponent,
    SavedItemsComponent,
    SteepnessProfileChartComponent,
    SurfaceProfileChartComponent,
    WaytypeProfileChartComponent,
    RatingComponent,

  ]
})
export class SharedModule {

}
